import {Flex, List, Text} from '@mantine/core';
import React from 'react';

import {VeritasHelpModalSection, VeritasHelpModalSectionTitle} from 'antibodies/format/help-modal/shared';

function BoldText({children}: {children: React.ReactNode}): JSX.Element {
  return (
    <Text span={true} fw="bold">
      {children}
    </Text>
  );
}

function SyntaxSymbol({text}: {text: string}): JSX.Element {
  return (
    <Text span={true} fw="bold" miw={200}>
      {text}
    </Text>
  );
}

export function BasicsTab(): JSX.Element {
  return (
    <div>
      <VeritasHelpModalSection>
        <VeritasHelpModalSectionTitle>Key concepts</VeritasHelpModalSectionTitle>
        <Text>The VERITAS scheme breaks down all antibody formats into modular components:</Text>
        <List pl="xl">
          <List.Item>
            <BoldText>N-terminal appendages:</BoldText> Modules attached to the N-terminus of the center
          </List.Item>
          <List.Item>
            <BoldText>Multimerization center:</BoldText> The core multimeric structure
          </List.Item>
          <List.Item>
            <BoldText>C-terminal appendages:</BoldText> Modules attached to the C-terminus of the center
          </List.Item>
        </List>
      </VeritasHelpModalSection>

      <VeritasHelpModalSection>
        <VeritasHelpModalSectionTitle>Syntax rules</VeritasHelpModalSectionTitle>
        <Flex>
          <SyntaxSymbol text="Dash -" />
          <Text span={true}>Connects modules on the same amino acid chain</Text>
        </Flex>
        <Flex>
          <SyntaxSymbol text="Asterisk *" />
          <Text span={true}>Separates modules on different amino acid chains</Text>
        </Flex>
        <Flex>
          <SyntaxSymbol text="Square brackets [ ]" />
          <Text span={true}>Denotes asymmetric appendages</Text>
        </Flex>
        <Flex>
          <SyntaxSymbol text="Colon :" />
          <Text span={true}>Indicates a non-covalent interaction between modules</Text>
        </Flex>
        <Flex>
          <SyntaxSymbol text="Parentheses ( )" />
          <Text span={true}>Labels a target specificity for the following module</Text>
        </Flex>
        <Flex>
          <SyntaxSymbol text="Exclamation point !" />
          <Text span={true}>Reverses the domains of the preceding module</Text>
        </Flex>
      </VeritasHelpModalSection>

      <VeritasHelpModalSection>
        <VeritasHelpModalSectionTitle>Symmetric vs. Asymmetric</VeritasHelpModalSectionTitle>
        <Text>
          <BoldText>Symmetric:</BoldText> Both chains have the same appendages
        </Text>
        <Text>
          <BoldText>Asymmetric:</BoldText> Chains have different appendages (use brackets)
        </Text>
      </VeritasHelpModalSection>
    </div>
  );
}
